import { type ReactNode } from 'react';
import { computeDayAxisLabels, type DayBucket } from '../utils/chart-buckets';
import { ChartBar } from './chart-bar';
import { ChartThresholds } from './chart-thresholds';

function Axis({ buckets }: { buckets: DayBucket[] }): ReactNode {
  const labels = computeDayAxisLabels(buckets);
  return (
    <div className="relative mt-1.5 h-3">
      {labels.map((l, i) => (
        <span
          key={i}
          className="absolute text-[10px] text-text-tertiary/30 -translate-x-1/2"
          style={{ left: `${l.pct}%` }}
        >
          {l.label}
        </span>
      ))}
    </div>
  );
}

type Props = { buckets: DayBucket[]; maxH: number };

export function ChartBars({ buckets, maxH }: Props): ReactNode {
  return (
    <>
      <div className="relative h-32 w-full">
        <ChartThresholds maxH={maxH} />
        <div className="relative flex h-full w-full items-end justify-end gap-1">
          {buckets.map((b) => (
            <ChartBar key={b.date} bucket={b} maxH={maxH} />
          ))}
        </div>
      </div>
      <Axis buckets={buckets} />
    </>
  );
}
